module.exports = __webpack_public_path__ + "img/Enmascarar grupo 16@2x.4b83b8c3.png";